module.exports = __webpack_public_path__ + "1.4.15-unryo/img/online-analytic-2.0f345a62.svg";